import { Pipe, PipeTransform } from '@angular/core';

/**
 * Filters `<mat-option>` source arrays by a search query, replacing PrimeNG's
 * `[filter]="true"` / `filterBy="a,b"` inputs that Material has no equivalent for.
 *
 * `keys` mirrors `filterBy`: the option properties to match against. Omit it for
 * arrays of plain strings.
 *
 * ```html
 * <mat-option *ngFor="let s of states | selectFilter: search.query : ['name', 'code']" …>
 * ```
 */
@Pipe({ name: 'selectFilter', standalone: true })
export class SelectFilterPipe implements PipeTransform {
  transform<T>(items: readonly T[] | null | undefined, query: string, keys: string[] = []): T[] {
    const list = items ? [...items] : [];
    const needle = (query ?? '').trim().toLowerCase();
    if (!needle) {
      return list;
    }

    return list.filter(item => {
      if (item === null || item === undefined) {
        return false;
      }
      if (typeof item !== 'object') {
        return String(item).toLowerCase().includes(needle);
      }
      const record = item as Record<string, unknown>;
      const fields = keys.length ? keys : Object.keys(record);
      return fields.some(key =>
        String(record[key] ?? '')
          .toLowerCase()
          .includes(needle)
      );
    });
  }
}
